<header
    class="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between py-3 mb-4 border-bottom bg-white px-4">
    <div class="col-md-3 mb-2 mb-md-0">
        <span class="text-muted">Welcome, Admin</span>
    </div>

    <div class="col-md-3 text-end">
        <button type="button" class="btn btn-outline-primary me-2">Logout</button>
    </div>
</header>